import { render } from "./Uninstall.vue?vue&type=template&id=55016d6a&scoped=true"
import script from "./Uninstall.vue?vue&type=script&lang=js"
export * from "./Uninstall.vue?vue&type=script&lang=js"

import "./footerPage.css?vue&type=style&index=0&id=55016d6a&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55016d6a"]])

export default __exports__